import api from "services/api";
import { TrafficAccidentReportForm } from "components/FeatureSendTrafficAccidentReport";
import { ApplicationMessageForm } from "types/ApplicationMessage";

class ApplicationMessageService {
  static sendReceiptsMessage = async ({
    attachments,
    title,
    message,
  }: ApplicationMessageForm) => {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("message", message);
    attachments.forEach(attachment => {
      formData.append("attachments", attachment);
    });

    return api.post("/application-message/receipts", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
  static sendSickLeaveMessage = async ({
    attachments,
    title,
    message,
  }: ApplicationMessageForm) => {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("message", message);
    attachments.forEach(attachment => {
      formData.append("attachments", attachment);
    });

    return api.post("/application-message/sick-leave", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  static sendTrafficAccidentReportMessage = async ({
    title,
    message,
    accidentLocation,
    otherPartyName,
    otherPartyPhone,
    otherPartyEmail,
    otherPartyOtherInfo,
    vehiclePhotos,
    otherPartyPhotos,
  }: TrafficAccidentReportForm) => {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("message", message);
    formData.append("accidentLocation", accidentLocation);
    if (otherPartyName) formData.append("otherPartyName", otherPartyName);
    if (otherPartyPhone) formData.append("otherPartyPhone", otherPartyPhone);
    if (otherPartyEmail) formData.append("otherPartyEmail", otherPartyEmail);
    if (otherPartyOtherInfo)
      formData.append("otherPartyOtherInfo", otherPartyOtherInfo);
    vehiclePhotos.forEach(doc => {
      formData.append("vehiclePhotos", doc.blob);
    });
    otherPartyPhotos.forEach(doc => {
      formData.append("otherPartyPhotos", doc.blob);
    });

    return api.post("/application-message/traffic-accident", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
}

export default ApplicationMessageService;
